import React, { useEffect, useState } from "react";
import Logo from "../../assets/img/Logo2.png";
import Image from "../../assets/img/Logo.png";
import { useNavigate, Link, useParams } from "react-router-dom";
import "../../styles/Admin.css";
import { useSelector } from "react-redux";
import { getData } from "../../services/api.service";
import { swalAlertDanger } from "../../components/common/Alerts";

const HomeAdmin = () => {
  const navigate = useNavigate();
  const { id_branch } = useParams();
  const dataUser = useSelector((state) => state.user.dataUser);
  const [branchInfo, setBranchInfo] = useState(null);
  const [loading, setLoading] = useState(true);

  // Función para obtener información de la sucursal
  const fetchBranchInfo = async () => {
    try {
      const res = await getData(`/api/admin/get_status_branch/${id_branch}`);
      if (res.status === 200) {
        setBranchInfo(res.data.branch[0]);
      } else {
        swalAlertDanger("Error al obtener información de la sucursal", "", () => {});
      }
    } catch (error) {
      swalAlertDanger("Error al obtener los datos", "", () => {});
    } finally {
      setLoading(false);
    }
  };

  // Validación de acceso de administrador y obtener datos de sucursal
  useEffect(() => {
    if (dataUser === null || dataUser.role_id !== 1) {
      navigate("/");
    } else {
      fetchBranchInfo();
    }
  }, [navigate, id_branch]);

  return (
    <div className="container">
      <Link to="/">
        <img src={Image} alt="logo" className="login-logo" />
      </Link>

      <div className="d-flex flex-column justify-content-center align-items-center min-vh-100 text-center">
        {/* Botón para volver a selección de sucursales */}
        <div className="align-self-start mb-3 mt-3">
          <button
            className="btn btn-outline-light d-flex align-items-center"
            onClick={() => navigate("/home/admin_panel")}
            style={{ fontSize: "0.9rem" }}
          >
            <span className="me-2">←</span>
            Cambiar Sucursal
          </button>
        </div>

        <h1 className="mb-2 admin-title">ADMINISTRADOR BILLY BROWNS</h1>
        
        {/* Información de la sucursal */}
        {loading ? (
          <div className="mb-4">
            <div className="spinner-border text-light" role="status" style={{ width: "1.5rem", height: "1.5rem" }}>
              <span className="visually-hidden">Cargando...</span>
            </div>
          </div>
        ) : (
          <div className="mb-4">
            <h3 className="text-success fw-bold">
              Sucursal: {branchInfo?.branch_name || `Sucursal #${id_branch}`}
            </h3>
            {branchInfo?.address && (
              <p className="text-white mb-2">📍 {branchInfo.address}</p>
            )}
            <span 
              className={`badge fs-6 px-3 py-2 ${
                branchInfo?.closed === 0 ? 'bg-success' : 'bg-danger'
              }`}
            >
              {branchInfo?.closed === 0 ? '🟢 Sucursal Abierta' : '🔴 Sucursal Cerrada'}
            </span>
          </div>
        )}

        <p className="mb-4 fs-5 admin-subtitle">
          Control total de tus productos, clientes y estadísticas en un solo
          lugar.
        </p>

        <div className="w-100 px-3 px-sm-0" style={{ maxWidth: "500px" }}>
          <div className="d-grid gap-3">
            <button
              className="btn admin-btn-orange position-relative"
              onClick={() => navigate(`/home/admin_panel/${id_branch}/products`)}
              style={{ padding: "1rem" }}
            >
              <div className="d-flex align-items-center justify-content-between">
                <span className="fw-bold">PRODUCTOS</span>
                <span style={{ fontSize: "1.5rem" }}>🍔</span>
              </div>
              <small className="d-block text-start mt-1 opacity-75">
                Gestionar hamburguesas, toppings y precios
              </small>
            </button>

            <button
              className="btn admin-btn-cian position-relative"
              onClick={() => navigate(`/home/admin_panel/${id_branch}/schedule`)}
              style={{ padding: "1rem" }}
            >
              <div className="d-flex align-items-center justify-content-between">
                <span className="fw-bold">HORARIOS</span>
                <span style={{ fontSize: "1.5rem" }}>🕒</span>
              </div>
              <small className="d-block text-start mt-1 opacity-75">
                Administrar horarios y estado de sucursal
              </small>
            </button>

            <button
              className="btn admin-btn-cream position-relative"
              onClick={() => navigate(`/home/admin_panel/${id_branch}/clients`)}
              style={{ padding: "1rem" }}
            >
              <div className="d-flex align-items-center justify-content-between">
                <span className="fw-bold">CLIENTES</span>
                <span style={{ fontSize: "1.5rem" }}>👥</span>
              </div>
              <small className="d-block text-start mt-1 opacity-75">
                Histórico de clientes y promociones
              </small>
            </button>

            <button
              className="btn admin-btn-green position-relative"
              onClick={() => navigate(`/home/admin_panel/${id_branch}/reports`)}
              style={{ padding: "1rem" }}
            >
              <div className="d-flex align-items-center justify-content-between">
                <span className="fw-bold">REPORTES</span>
                <span style={{ fontSize: "1.5rem" }}>📊</span>
              </div>
              <small className="d-block text-start mt-1 opacity-75">
                Estadísticas y reportes de ventas
              </small>
            </button>
          </div>
        </div>

        <img src={Logo} alt="LogoBottom" className="w-50 d-flex mx-auto mt-5" />
      </div>
    </div>
  );
};

export default HomeAdmin;
